import { useWalletConnection } from "@/hooks";
import { Button, type ButtonProps } from "@/components";
import type React from "react";
import { useConnectModal } from "@rainbow-me/rainbowkit";

const connectText = "Connect Wallet";

export function WalletGatedButton({ onClick, children, className, type = "submit", ...buttonProps }: ButtonProps) {
    const { isConnected, isConnecting } = useWalletConnection();
    const { openConnectModal } = useConnectModal();

    const handleClick = async (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        if (!isConnected) {
            openConnectModal?.();
        } else {
            onClick?.(e);
        }
    };

    return (
        <Button
            onClick={(event) => handleClick(event)}
            isLoading={isConnecting}
            type={isConnected ? type : undefined}
            {...buttonProps}
            disabled={isConnecting || buttonProps.disabled}
            variant="primary"
            fullWidth
        >
            {!isConnected && !isConnecting ? connectText : children}
        </Button>
    );
}
